import { Component, Input } from "@angular/core";


@Component({
    selector: 'app-text-column',
    template: `
    {{ value }}
    `,
    standalone: true,
    imports: [
    ],
    styles: [
        `
        `
    ]
})

export class TextColumnComponent {
@Input() value: string = '';
}